import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import type { SerdeContextDataInterface } from '@zaoblako/shared/modules/serde/interfaces/serde-context-data.interface';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { validateForm } from '@zaoblako/web/core/services/validation/validate.service';
import { ValidationService } from '@zaoblako/web/core/services/validation/validation.service';

@Component({
  selector: 'crm-base-form',
  template: ''
})
export abstract class BaseFormComponent<T> {
  @Input() public saveButtonLabel = 'Сохранить';
  @Input() public canDelete = false;
  @Output() public save = new EventEmitter<T>();
  @Output() public delete = new EventEmitter<T>();

  @Input() public route: string;
  public errors: T extends Array<infer I> ? Array<ValidationErrorInterface<I>> : ValidationErrorInterface<T>;

  @Input() public isModal = false;

  public abstract dto: (new () => T) | SerdeDtoClass<T>;

  /** Form validation "engine" to use */
  public engine: 'class-transformer' | 'serde' = 'class-transformer';

  public readonly validationService = inject(ValidationService);
  private readonly _errorService = inject(ErrorService);

  public onSave<D extends SerdeContextDataInterface = SerdeContextDataInterface>(entity: T, contextData?: D) {
    if (this.engine === 'class-transformer') {
      const { valid, errors } = validateForm(entity, this.dto as new () => T);
      if (!valid) {
        this.errors = errors?.validationErrors;
        console.error(this.errors);
        this._errorService.addCustomError(
          'Ошибка валидации',
          Object.keys(this.errors)
            .map((key) => `[${key}]: ${this.errors[key]};`)
            .join('\n')
        );
      } else {
        this.errors = null;
        this.save.emit(entity);
      }
    } else {
      const [result, errors] = this.validationService.parseAndValidate<T, D>(
        entity,
        this.dto as SerdeDtoClass<T>,
        contextData
      );
      if (errors) {
        this.errors = errors.validationErrors;
        console.log(entity);
        console.error(this.errors);
        this._errorService.addCustomError(
          'Ошибка валидации',
          Object.keys(this.errors)
            .map((key) => `[${key}]: ${this.errors[key]};`)
            .join('\n')
        );
      } else {
        this.errors = null;
        this.save.emit(result);
      }
    }
  }

  public checkValidate<D extends SerdeContextDataInterface = SerdeContextDataInterface>(entity: T, contextData?: D) {
    if (this.engine === 'class-transformer') {
      const { valid, errors } = validateForm(entity, this.dto as new () => T);
      if (!valid) {
        this.errors = errors?.validationErrors;
        console.error(this.errors);
      } else {
        this.errors = null;
      }
      return { valid, errors };
    } else {
      const [result, errors] = this.validationService.parseAndValidate<T, D>(
        entity,
        this.dto as SerdeDtoClass<T>,
        contextData
      );
      if (errors) {
        this.errors = errors.validationErrors;
        console.log(entity);
        console.error(this.errors);
      } else {
        this.errors = null;
      }
      return {
        errors,
        valid: !!result
      };
    }
  }
}
